var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "已报名球队列表",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "popover", staticStyle: { "flex-direction": "column" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "球队名称", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "logo", label: "球队logo", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("el-image", {
                          staticStyle: { width: "60px", height: "60px" },
                          attrs: { src: row.logo, fit: "cover" }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "introduction", label: "球队简介" }
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.status == 0
                          ? _c("span", [_vm._v("待审核")])
                          : _vm._e(),
                        row.status == 1
                          ? _c("span", [_vm._v("已通过")])
                          : _vm._e(),
                        row.status == 2
                          ? _c("span", [_vm._v("已拒绝")])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "80",
                  align: "center",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "x-c" },
                          [
                            row.status == 0
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      placement: "bottom",
                                      effect: "light",
                                      "visible-arrow": "true"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content"
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.passClick(row.id, 1)
                                              }
                                            }
                                          },
                                          [_vm._v("通过")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.$refs.unseal.init(
                                                  row.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("拒绝")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "controlsBtn" }, [
                                      _vm._v("审核")
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.tableData.length
            ? _c("el-pagination", {
                attrs: {
                  layout: "total, prev, pager, next",
                  "current-page": _vm.paramsData.page,
                  total: _vm.total,
                  "page-size": 10
                },
                on: { "current-change": _vm.getTeamListFn }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      ),
      _c("unseal", {
        ref: "unseal",
        on: {
          change: function($event) {
            return _vm.getTeamListFn(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }